// Rich description helpers. The lists must match backend/services/rich_text.py (the server keeps only these values).
export const COLORS = [
  { name: 'Charcoal', value: '#111417' }, { name: 'Navy', value: '#0D1B2A' }, { name: 'Steel blue', value: '#4575A8' },
  { name: 'Slate', value: '#5C6370' }, { name: 'Green', value: '#4A7C59' }, { name: 'Gold', value: '#C4A561' },
  { name: 'Bronze', value: '#8A6A22' }, { name: 'Red', value: '#B45353' },
];
export const SIZES = [
  { name: 'Small', value: '12px' }, { name: 'Normal', value: null }, { name: 'Large', value: '18px' }, { name: 'Heading', value: '22px' },
];
export const FONTS = [
  { name: 'Default', value: null }, { name: 'Exo 2', value: '"Exo 2", sans-serif' }, { name: 'Arial', value: 'Arial, sans-serif' },
  { name: 'Helvetica', value: 'Helvetica, Arial, sans-serif' }, { name: 'Verdana', value: 'Verdana, sans-serif' },
  { name: 'Trebuchet MS', value: '"Trebuchet MS", sans-serif' }, { name: 'Georgia', value: 'Georgia, serif' },
  { name: 'Times New Roman', value: '"Times New Roman", serif' }, { name: 'Garamond', value: 'Garamond, serif' },
];

const RICH = /<\s*\/?\s*(p|br|ul|ol|li|span|strong|em|u|b|i|a|img)\b/i;
export const isRich = (s) => RICH.test(s || '');

const esc = (t) => t.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
// Plain text (a description saved before formatting existed) → paragraphs; a single line break stays one.
export const toEditorHtml = (s) => {
  if (!s) return '';
  if (isRich(s)) return s;
  return s.split(/\n{2,}/).map((p) => `<p>${esc(p).replace(/\n/g, '<br>')}</p>`).join('');
};

// One plain line for previews (library rows, estimate lines).
export function toPlainText(s) {
  if (!isRich(s)) return (s || '').replace(/\s+/g, ' ').trim();
  const doc = new DOMParser().parseFromString(s, 'text/html');
  doc.body.querySelectorAll('br').forEach((b) => b.replaceWith(' '));
  doc.body.querySelectorAll('p, li').forEach((b) => b.append(' '));
  return doc.body.textContent.replace(/\s+/g, ' ').trim();
}

const fontKey = (v) => (v || '').split(',').map((p) => p.trim().replace(/^['"]|['"]$/g, '').toLowerCase()).join(',');
const hex = (v) => {
  const m = /^rgba?\((\d+),\s*(\d+),\s*(\d+)/i.exec(v || '');
  return (m ? `#${m.slice(1, 4).map((x) => Number(x).toString(16).padStart(2, '0')).join('')}` : v || '').toLowerCase();
};
export const fontOf = (v) => FONTS.find((f) => fontKey(f.value) === fontKey(v)) || FONTS[0];
export const sizeOf = (v) => SIZES.find((x) => x.value === (v || null)) || SIZES[1];
export const colorOf = (v) => COLORS.find((c) => c.value.toLowerCase() === hex(v)) || null;

// What someone typed into the link box → a link the server keeps, or null. "belgard.com" → https://, an email → mailto:.
export function normalizeLink(raw) {
  const v = (raw || '').trim();
  if (!v || /\s/.test(v)) return null;
  if (/^(https?:\/\/|mailto:)/i.test(v)) return v.length <= 2000 ? v : null;
  if (/^[^@/]+@[^@/]+\.[a-z]{2,}$/i.test(v)) return `mailto:${v}`;
  if (/^[a-z0-9-]+(\.[a-z0-9-]+)+([/?#].*)?$/i.test(v)) return `https://${v}`;
  return null;
}
